import SliderComp from "../SliderComp";
import { googleReviews } from "../../data/testimonials";
import styles from "./Testimonials.module.css";

export default function Testimonials() {
  return (
    <section className={styles.section}>
      <div className={`container ${styles.shell}`}>
        <div className={styles.content}>
          <span className={styles.kicker}>Clients Testimonials</span>
          <h2>
            Clients trust our clear, consistent, and confident billing support.
          </h2>
          <p>
            We work closely with healthcare teams to simplify the billing
            experience, reduce friction, and create a service relationship built
            on responsiveness and trust.
          </p>
        </div>

        <div className={styles.sliderColumn}>
          <SliderComp testimonials={googleReviews} />
        </div>
      </div>
    </section>
  );
}
